import { create } from "apisauce";

const mapDomainsToId = {
  "bebanca.com.br": "8CzkqnNkLDSi-dyFi8Kc",
  "www.bebanca.com.br": "8CzkqnNkLDSi-dyFi8Kc",
  "accounts.bebanca.com.br": "8CzkqnNkLDSi-dyFi8Kc",
  "stage.bebanca.com.br": "8CzkqnNkLDSi-dyFi8Kc",

  "jornaleironaweb.com.br": "i1xJzzhKKSsCDSxFi5yj",
  "www.jornaleironaweb.com.br": "i1xJzzhKKSsCDSxFi5yj",
  "accounts.jornaleironaweb.com.br": "i1xJzzhKKSsCDSxFi5yj",
  "stage.jornaleironaweb.com.br": "i1xJzzhKKSsCDSxFi5yj",

  "begamer.com.br": "LDSi-dyFi8KcsCDSxFi5yj",
  "www.begamer.com.br": "LDSi-dyFi8KcsCDSxFi5yj",
  "accounts.begamer.com.br": "LDSi-dyFi8KcsCDSxFi5yj",
  "stage.begamer.com.br": "LDSi-dyFi8KcsCDSxFi5yj",
  "accounts.begamer.app": "LDSi-dyFi8KcsCDSxFi5yj",
  "begamer.app": "LDSi-dyFi8KcsCDSxFi5yj"
};

export const apiKey =
  mapDomainsToId[window.location.host] || "8CzkqnNkLDSi-dyFi8Kc";

const api = create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "x-api-key": apiKey }
});

api.addRequestTransform(req => {
  if (window.localStorage.getItem("authToken")) {
    req.headers = {
      Authorization: window.localStorage.getItem("authToken"),
      "x-api-key": apiKey
    };
  }
});

api.addMonitor(({ status, data }) => {
  if (status === 401 && data.error === "Invalid Request") {
    window.localStorage.removeItem("authToken");
    window.location.href = "/signin";
  }
});

export default api;



// WEBPACK FOOTER //
// ./src/services/api.js